/**
 * Provides a cms gui.
 * @module gui/pages/content
 */
import React from 'react'

// Redux
import redirectsMiddleware from 'services/url-redirects/redux/middleware'
import redirectsReducer, { initialState as redirectsInitialState } from 'services/url-redirects/redux/reducers'
import contentSearchMiddleware from 'services/content-search/redux/middleware'
import contentSearchReducer, { initialState as contentSearchInitialState } from 'services/content-search/redux/reducers'
// Components
import ContentPage from 'gui/components/content-page'

import { start as startApp } from '..'

/**
 * Entry point for the user management page
 */
async function start () {
  const children = <ContentPage />
  await startApp({
    middleware: [
      contentSearchMiddleware,
      redirectsMiddleware,
    ],
    reducers: {
      csParams: contentSearchReducer,
      redirects: redirectsReducer,
    },
    initialState: {
      csParams: contentSearchInitialState,
      redirects: redirectsInitialState,
    },
    children,
  })
}

if (!module.parent) {
  start()
}
